<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog
      v-model="dialogActivateInactivateIssuer"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar dark dense class="elevation-0" color="primary">
          <v-icon small class="mr-2">{{
            StoreObj.issuer_status == "ACTIVE" ? "mdi-cancel" : "mdi-check"
          }}</v-icon>
          <div
            v-text="
              StoreObj.issuer_status == 'ACTIVE' ? 'Deactivate' : 'Activate'
            "
          ></div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogActivateInactivateIssuerEmit((Toggle = 1))"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text align="center">
          <v-icon
            class="mt-5"
            size="50px"
            :color="StoreObj.issuer_status == 'ACTIVE' ? 'red' : 'green'"
            >{{
              StoreObj.issuer_status == "ACTIVE" ? "mdi-cancel" : "mdi-check"
            }}</v-icon
          >
          <div>
            Are you Sure you want to
            <span
              v-text="
                StoreObj.issuer_status == 'ACTIVE' ? 'Deactivate' : 'Activate'
              "
            ></span>
            {{ StoreObj.issuer_name }} ?
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius"
            color="secondary"
            outlined
            @click="dialogActivateInactivateIssuerEmit((Toggle = 1))"
            ><v-icon small class="mr-1">mdi-close</v-icon>Cancel</v-btn
          >
          <v-btn
            small
            class="mr-2 borderRadius"
            color="secondary"
            @click="changeStatus()"
            :loading="loading"
            ><v-icon small class="mr-1">mdi-check</v-icon>Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Snackbar from "@/components/Extras/Snackbar.vue";
import { UpdateIssuer } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
export default {
  props: {
    dialogActivateInactivateIssuer: Boolean,
    StoreObj: Object,
  },
  components: {
    Snackbar,
  },
  data: () => ({
    Toggle: 0,
    loading: false,
    SnackBarComponent: {},
  }),
  methods: {
    async changeStatus() {
      try {
        var inputParams = {
          issuer_id: this.StoreObj.issuer_id,
          user_email_id: this.$store.getters.get_user_email,
          update_type: "UPDATE_STATUS",
          issuer_status:
            this.StoreObj.issuer_status == "ACTIVE" ? "INACTIVE" : "ACTIVE",
        };
        this.loading = true;
        let result = await API.graphql(
          graphqlOperation(UpdateIssuer, {
            input: inputParams,
          })
        );
        var ResultObject = JSON.parse(result.data.UpdateIssuer);
        if (ResultObject.status == "Success") {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: ResultObject.Status_Message,
          };
          this.dialogActivateInactivateIssuerEmit((this.Toggle = 2));
        }
        this.loading = false;
      } catch (error) {
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.errors[0].message,
        };
        this.loading = false;
      }
    },
    dialogActivateInactivateIssuerEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
